import {http} from "../http-common";
import { Country } from "../models/Country";

class CountryDataService {
    async getAll() {
        return await http().get<Array<Country>>("/countries");
    }
}
export default new CountryDataService();